(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
// #region agent log
(() => {
  try {
    const el = document.querySelector('.section-article');
    if (!el) return;
    const payload = {
      sessionId: '4c88df',
      runId: 'pre-fix',
      hypothesisId: 'H1-H5',
      location: 'sections/article.liquid:ABD_DEBUG',
      message: 'ABD theme resolution snapshot',
      data: {
        theme: el.getAttribute('data-abd-theme'),
        themeSource: el.getAttribute('data-abd-theme-source'),
        themeRaw: el.getAttribute('data-abd-theme-raw'),
        className: el.className,
        protocol: window.location.protocol,
        host: window.location.host
      },
      timestamp: Date.now()
    };
    if (window.location.protocol === 'http:' && (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost')) {
      fetch('http://127.0.0.1:7292/ingest/0a002a59-69bd-4a9c-931c-21017c2fcf1e', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '4c88df' },
        body: JSON.stringify(payload)
      }).catch(() => {});
    }
    window.__ABD_DEBUG__ = payload.data;
  } catch (e) {}
})();
// #endregion

  } catch(e) { console.error(e); }
})();
})();
